import { render, staticRenderFns } from "./AnagraficaSoggetti.vue?vue&type=template&id=2dd11fd7&scoped=true&"
import script from "./AnagraficaSoggetti.vue?vue&type=script&lang=js&"
export * from "./AnagraficaSoggetti.vue?vue&type=script&lang=js&"
import style0 from "./AnagraficaSoggetti.vue?vue&type=style&index=0&id=2dd11fd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd11fd7",
  null
  
)

export default component.exports